import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MessageLayout from "../../../sections/MessageCentre/MessageLayout";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import AllChats from "../../../sections/MessageCentre/AllChats";
import { BUSINESS_INBOX_CONTENT_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";
import Avtar from "../../../assets/img/default-image.jpg";

const Messages = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [msgOpening, setMsgOpening] = useState(() => {
    const viewParam = new URLSearchParams(location.search).get('view');
    return viewParam === 'message' ? 2 : 1;
  });

  useEffect(() => {
    if (msgOpening === 2) {
      navigate(`${location.pathname}?view=message`, { replace: true });
    } else {
      navigate(location.pathname, { replace: true });
    }
  }, [msgOpening, navigate, location.pathname]);

  useEffect(() => {
    const viewParam = new URLSearchParams(location.search).get('view');
    if (viewParam !== 'message' && msgOpening === 2) {
      setMsgOpening(1);
    }
  }, [location.search]);

  return (
    <>
      <DashboardMainContainer className={"!bg-white"}>
        {msgOpening === 1 && (
          <div className={BUSINESS_INBOX_CONTENT_CLASS}>
            <div className="bg-white overflow-hidden">
              <AllChats moveToChat={() => setMsgOpening(2)} filterType="all" hideGroupQuotes={true} />
            </div>
          </div>
        )}
        {msgOpening === 2 && (
          <div className={BUSINESS_INBOX_CONTENT_CLASS}>
          <MessageLayout
              moveBack={() => setMsgOpening(1)}
              profileImage={Avtar}
              messenger={"Aaqib Javaid"}
              businessProfileLink={true}
              customerprofileImage={Avtar}
              customermessenger={"Saim sahi"}
              timing={"34 minutes ago"}
              customerconversationText={
                "Of course, I'd be happy to! Here's a short poem for you In twilight's hush, the stars arise Whispering"
              }
              conversationText={
                "Of course, I'd be happy to! Here's a short poem for you In twilight's hush, the stars arise Whispering secrets in the skies Moonlight dances, shadows play, Night unfolds its silent sway."
              }
            />
          </div>
        )}
      </DashboardMainContainer>
    </>
  );
};

export default Messages;
